import React from 'react';
import Button from '@material-ui/core/Button';
import {RepProfileAndName} from 'components/coaching/landing-pages/helpers/ProfileAndName';
import theme from 'styles/theme';
import {noData} from 'components/coaching/landing-pages/helpers';
import withSorting from 'components/pure/sortable-tables/withSorting';
import {List} from 'immutable';
import SortableTableHeader from 'components/pure/sortable-tables/SortableTableHeader';
import classNames from 'classnames';
import './InactiveRepsList.styl';
import {
  compareNumeric,
  compareReps,
  compareStrings,
} from 'components/coaching/landing-pages/helpers/tableSorts';

const headerData = [
  {label: 'Rep', column: 'rep', className: 'active-rep'},
  {label: 'Challenged By', column: 'challengedBy', className: 'challenged-by'},
  {label: 'Activity Rank', column: 'activityRank', className: 'activity-rank'},
  {
    label: 'Self-Review Rank',
    column: 'selfReviewRank',
    className: 'self-review-rank',
  },
];

// TODO: a must be replaced with button and eslint ignore must be removed
/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */

/**
 * Display reps that report to this manager that do not have active coaching plans
 *
 * Details skill rankings across their respective team, with a call to action to create a new plan,
 * loading spinner if we haven't loaded the skill rankings yet
 */
class InactiveRepsList extends React.PureComponent {
  renderTableRows(sortedData, adminId, manager, coachId, startDate, endDate, fromPath) {
    return sortedData.map(({rep, challengedBy, activityRank, selfReviewRank}) => {
      return (
        <tr key={rep.userId}>
          <td className={classNames('coaching-profile-container', 'rep')}>
            <RepProfileAndName
              rep={rep}
              coachId={coachId}
              manager={manager}
              adminId={adminId}
              fromPath={fromPath}
            />
          </td>
          <td className={'challengedBy'}>{challengedBy ? challengedBy : noData}</td>
          {activityRank ? (
            <td className={'activityRank'}>{this.renderFancyRank(activityRank)}</td>
          ) : (
            <td />
          )}
          {selfReviewRank ? (
            <td className={'selfReviewRank'}>{this.renderFancyRank(selfReviewRank)}</td>
          ) : (
            <td />
          )}
          <td>
            <div className="button-wrapper">
              {this.props.hasNoCallReviewType && (
                <Button
                  variant="text"
                  className="ev-button"
                  onClick={() => this.props.onCoachNow({rep})}>
                  Coach Now
                </Button>
              )}
              <Button
                variant="outlined"
                className="ev-button"
                onClick={() => this.props.onCreatePlan({rep, coach: manager})}>
                Create Plan
              </Button>
            </div>
          </td>
        </tr>
      );
    });
  }

  renderFancyRank(activity) {
    // if value is zero, don't bother trying to display their rank at all

    if (activity.value === 0) {
      return <span className="no-data">N/A</span>;
    }

    // otherwise,
    // subdivide the ranks into thirds
    // bottom third (HIGHEST numbers) get red
    // middle get grey
    // top (LOWEST numbers) get green

    let color = theme.palette.lynch;

    if (activity.outOf === 1) {
      color = theme.palette.lynch;
    } else if (activity.rank - 1 <= (activity.outOf - 1) * (1 / 3)) {
      color = theme.palette.topRank;
    } else if (activity.rank - 1 >= (activity.outOf - 1) * (2 / 3)) {
      color = theme.palette.bottomRank;
    }

    return (
      <span className="rank">
        # <span style={{color: color}}>{activity.rank}</span> / {activity.outOf}
      </span>
    );
  }

  render() {
    const {
      sortedData,
      onSort,
      sortDirection,
      sortColumn,
      haveInactiveReps,
      startDate,
      endDate,
      manager,
      adminId,
      coachId,
      fromPath,
    } = this.props;

    if (!haveInactiveReps) return null;

    return (
      <div className="mgr-landing-card-container">
        <table>
          <thead>
            <tr>
              {headerData.map(data => (
                <th key={data.label} className={data.className}>
                  <SortableTableHeader
                    label={data.label}
                    renderColumn={data.column}
                    onClick={() => onSort(data.column, sortDirection)}
                    sortDirection={sortDirection}
                    sortColumn={sortColumn}
                  />
                </th>
              ))}
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {this.renderTableRows(
              sortedData,
              adminId,
              manager,
              coachId,
              startDate,
              endDate,
              fromPath
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

const gatherData = props => {
  const {inactiveReps, coachingPlans, skillBreakdowns, activityRankings} = props;

  if (!coachingPlans) {
    return List();
  }

  // gather reps and their rankings
  const repsAndRankings = inactiveReps.map(rep => [
    rep,
    skillBreakdowns.get(rep.userId),
    activityRankings.find(r => r.userId === rep.userId),
  ]);

  return repsAndRankings.map(([rep, sb, activityRankings]) => {
    return {
      rep: rep,
      challengedBy: sb?.worstSkill?.skillName,
      activityRank: activityRankings ? activityRankings.callActivity : null,
      selfReviewRank: activityRankings ? activityRankings.selfReviewActivity : null,
    };
  });
};

export default withSorting(InactiveRepsList, props => gatherData(props), {
  rep: compareReps,
  challengedBy: (l, r) => compareStrings(l.challengedBy, r.challengedBy),
  activityRank: (l, r) => compareNumeric(l.activityRank.rank, r.activityRank.rank),
  selfReviewRank: (l, r) => compareNumeric(l.selfReviewRank.rank, r.selfReviewRank.rank),
});
